{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -80.23573540305628,
              -3.309425645815054
            ],
            [
              -80.4432772202309,
              -4.22327861469725
            ],
            [
              -79.1528748955958,
              -4.973674822778634
            ],
            [
              -75.64213677269153,
              -1.584765943366321
            ],
            [
              -78.94049022929966,
              1.5255002393408859
            ],
            [
              -93.38599602867485,
              1.3588075228277887
            ],
            [
              -92.59264744466863,
              -2.48606373904596
            ],
            [
              -80.23573540305628,
              -3.309425645815054
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}